import { render, staticRenderFns } from "./InviterListWindow.vue?vue&type=template&id=740d3aa2&scoped=true"
import script from "./InviterListWindow.vue?vue&type=script&lang=js"
export * from "./InviterListWindow.vue?vue&type=script&lang=js"
import style0 from "./InviterListWindow.vue?vue&type=style&index=0&id=740d3aa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740d3aa2",
  null
  
)

export default component.exports